import {ApplyReverseGeocodeToAddressFormParams} from './types';

function applyReverseGeocodeToAddressForm({
	data,
	onZipCodeFilled,
	onAddressFieldsFilled,
	onWarningCleared,
}: ApplyReverseGeocodeToAddressFormParams) {
	if (!data) return;

	if (data.cep) {
		onZipCodeFilled(data.cep);
	}

	onAddressFieldsFilled(
		{
			nmUf: data.state ?? '',
			nmCidade: data.city ?? '',
			nmBairro: data.neighborhood ?? '',
			nmTipoLogradouro: '',
			nmRua: data.street ?? '',
		},
		true,
	);
	onWarningCleared();
}

export {applyReverseGeocodeToAddressForm};
